export default __webpack_public_path__ + "static/media/noFolder.b0f8513e.svg";